import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { INSIGHTS } from "@/data/site";

export default function Insights() {
  const [featured, ...rest] = INSIGHTS;
  return (
    <div data-testid="insights-page">
      <section className="pt-16 pb-16 md:pt-24 md:pb-20 border-b border-[#E5E5E5]">
        <div className="container-cc">
          <div className="overline mb-8"><span className="kicker-line" />Insights</div>
          <h1 className="font-serif-display text-5xl md:text-7xl leading-[1.02] max-w-5xl">
            Field notes on culture, <span className="italic text-[#A60201]">engagement</span> and the future of work.
          </h1>
        </div>
      </section>

      <section className="section">
        <div className="container-cc">
          <Link to={`/insights/${featured.slug}`} data-testid={`featured-insight`} className="group grid grid-cols-1 lg:grid-cols-12 gap-10 items-center mb-20 hover:opacity-90 transition-opacity">
            <div className="lg:col-span-7">
              <div className="aspect-[16/10] overflow-hidden">
                <img src={featured.image} alt={featured.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
            </div>
            <div className="lg:col-span-5">
              <div className="overline text-[#A60201] mb-4">Featured · {featured.category}</div>
              <h2 className="font-serif-display text-4xl md:text-5xl leading-tight group-hover:text-[#A60201] transition-colors">{featured.title}</h2>
              <p className="mt-5 text-[#525252] leading-relaxed">{featured.excerpt}</p>
              <div className="text-sm text-[#525252] mt-6">{featured.date} · {featured.readTime}</div>
              <span className="link-underline mt-6">Read article <ArrowUpRight size={16} /></span>
            </div>
          </Link>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {rest.map((p) => (
              <Link key={p.slug} to={`/insights/${p.slug}`} data-testid={`insight-${p.slug}`} className="group">
                <div className="aspect-[4/3] overflow-hidden mb-5 bg-[#F3F4F6]">
                  <img src={p.image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="overline text-[#A60201] mb-2">{p.category}</div>
                <h3 className="font-serif-display text-2xl leading-tight group-hover:text-[#A60201] transition-colors">{p.title}</h3>
                <p className="mt-3 text-sm text-[#525252] leading-relaxed">{p.excerpt}</p>
                <div className="text-sm text-[#525252] mt-4">{p.date} · {p.readTime}</div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
